function Banklink() {
  const self = this;

  self.init = function (params) {
    return {
      paymentIsSuccess: params.paymentStatus === 'success',
      paymentIsFailure: params.paymentStatus === 'failure',
      paymentIsUnknown: params.paymentStatus !== 'success' && params.paymentStatus !== 'failure'
    }
  }
}